module.exports = __webpack_public_path__ + "img/Mouse.1a6f3e3b.svg";